var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-select',{staticClass:"flex-1 mb-20",attrs:{"value":_vm.value,"select-label":"Leverandør","label":"full_name","reduce":user => user.id,"options":_vm.users,"disabled":_vm.disabled,"select-name":"rolle","clearable":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }